module.exports = __webpack_public_path__ + "img/avp_bck_alt_large@2x.2cbc62f.webp";